import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/faq';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="使用前你可能想先了解这些"
          desc="整理了关于内容分类、筛选方式和追番清单的常见疑问，点击问题即可展开查看回答。"
          align="center"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                        open ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-4 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}